module.exports = __webpack_public_path__ + "img/last-badge-overall.0dd28525.svg";